export const main = {
	yhxm:'用户姓名',
	qrxx:'确认信息填写',
    mmdl:'密码登录',
    yzmdl:'验证码登录',
    sjhm:"手机号码",
    qsrmm:'请输入密码',
    wjmm:'忘记密码',
    dl:'登录',
    zcxzh:'注册新账号',
    yzm:'验证码',
    hqyzm:'获取验证码',
    sryx:'输入邮箱',
    zcsrmm:'再次输入密码',
    yqm:'请输入邀请码/邀请人手机号',
    sjyz:'手机验证',
    yxyz:'邮箱验证',
    tyxyhzc:'我同意用户协议和隐私政策',
    ty:'我已阅读并同意',
    yhxy:'用户协议',
    yszc:'隐私政策',
    zce:'注册',
    zyzhljdl:'已有帐号，立即登录',
    wdzc:'我的资产',
    wdzh:'我的账户',
    tbgl:'同步管理',
    fbxh:'发布信号',
    xhsc:'信号市场',
    czsc:'操作手册',
    tcxh:'退出信号',
    ye:'余额',
    jz:'净值',
    jyss:'交易手数',
    ccyl:'持仓盈利',
    xvh:'序号',
    sftb:'是否同步',
    fwq:'服务器',
    zh:'账号',
    zyk:'总盈亏',
    kds:'开单数',
    zhzt:'账号状态',
    cz:'操作',
    s:'是',
    f:'否',
    zc:'正常',
    yc:'异常',
    ck:'查看',
    cpyk:'产品盈亏',
    zss:'总手数',
    jypz:'交易品种',
    sy:'收益',
    sszb:'手数占比',
    cczh:'持仓总汇',
    ddh:'订单号',
    jyl:'交易量',
    kcsj:'开仓时间',
    kcjg:'开仓价格',
    bjjg:'标记价格',
    zyzs:'止盈/止损',
    gylx:'隔夜利息',
    yk:'盈亏',
    xzcksj:'请在账户中选择要查看的数据',
    tbyk:'同步盈亏',
    ccsj:'持仓时间',
    pcsj:'平仓时间',
    tjzh:'添加账户',
    bz:'备注',
    sfwxh:'是否为信号',
    tbzt:'同步状态',
    ytb:'已同步',
    wtb:'未同步',
    qyjy:'启用/禁用',
    yqy:'已启用',
    yjy:'已禁用',
    xgzhmm:'修改密码',
    gbxh:'关闭信号',
    sczh:'删除账号',
    qw:'前往',
    y:'页',
    tjglzh:'添加关联账户',
    qxz:'请选择',
    qsrzh:'请输入账号',
    mm:'密码',
    qsrbz:'请输入备注',
    sjsqxhts:'真实账户主密码授权可升级成为社区信号',
    qr:'确认',
    qx:'取消',
    zhjy:'账号*****是否将其置为禁用状态',
    zhqy:'账号*****是否将其置为启用状态',
    dqdlmm:'当前登录密码',
    xzhmm:'新账号密码',
    qrxmm:'确认新密码',
    qsrdqdlmm:'请输入当前登录密码',
    qsrxmm:'请输入新密码',
    qzcsrxmm:'请再次输入新密码',
    yhzl:'用户资料',
    jcxx:'基础信息',
    tx:'头像',
    sczp:'上传照片',
    tudxxz:'请选择图片上传：大小413*626像素，支持JPG、PNG等格式，图片需小于2M。',
    gjhdq:'国家和地区',
    dzyx:'电子邮箱',
    bcxg:'保存修改',
    zhaq:'账号安全',
    dqmm:'当前密码',
    xmm:'新密码',
    qrmm:'确认密码',
    qsrdqmm:'请输入当前密码',
    qd:'确定',
    tjtb:'添加同步',
    tb:'同步',
    xh:'信号',
    qsrnr:'请输入内容',
    tbzh:'同步账号',
    qxztbzh:'请选择同步账号（多选）',
    jygz:'交易规则',
    bzjdb:'保证金等比',
    jzdb:'净值等比',
    kyzjdb:'可用资金等比',
    jyldb:'交易量等比',
    gdssdb:'固定手数等比',
    jycs:'交易参数',
    kcjybc:'开仓价优补偿',
    xhsxzdpc:'信号失效自动平仓',
    zdss:'最大手数',
    zdhc:'最大回撤',
    jsbz:'均以国际标准合约为计算标准（货币对国际标准合约100000；黄金国际标准合约100盎司；白银国际标准合约5000盎司；原油国际标准合 约1000桶)',
    pctbts:'部分平仓以及平仓被操作 基于不同平台终端的操作规则不同，同步过程暂不支持 烦请知悉.',
    tbxh:'同步信号',
    tbms:'同步模式',
    tbxs:'同步系数',
    tbsz:'同步设置',
    xgcs:'修改参数',
    yzttb:'已暂停同步',
    ykqtb:'已开启同步',
    sctb:'删除同步',
    xgtbcs:'修改同步参数',
    cgtbzt:'修改同步状态',
    sfqkzhdtb:'是否 开启 当前账号*******的同步操作？',
    sfztzhdtb:'是否 暂停 当前账号*******的同步操作？',
    tjxh:'添加信号',
    nsyl:'年收益率',
    zt:'状态',
    dyz:'订阅者',
    kstbsj:'开始同步时间',
    zwsj:'暂无数据',
    xzzh:'选择账号',
    qxzzh:'请选择账号',
    qqdxhhtbzzt:'请确定您的信号和同步者的现状，以免出现无限循环风险',
    xhm:'信号名',
    qsrxhm:'请输入信号名（最多十五个字符）',
    xhmts:'信号名：一个账户对应一个信号名，一旦确认将不可更改',
    gszzdjz:'跟随者最低净值',
    sfgkxh:'是否公开信号',
    gk:'公开',
    sm:'私密',
    gsddzs:'跟随订单注释',
    gsddzsts:'您在此处填写的内容将显示在所有跟随者的MT订单注释处',
    jdzyjgyhkf:'仅对专业/机构用户开放',
    xhms:'信号描述',
    shili:'示例：该账户主做短线，日内单，单单带止盈止损，建议2000美金手数1:1同步！',
    clmsts:'为了保护所有用户的隐私，策略描述里不允许包含任何联系方式',
    xhlb:'信号列表',
    xhlbts:'注：信号提供者均为第三方用户，同步服务可能会出现延迟，所有交易数据均采集自MT4/MT5服务器',
    xhy:'信号源',
    zongsyl:'总收益率',
    zhousyl:'周收益率',
    jqtjycs:'近7天交易次数',
    irrqzsy:'IRR权重收益',
    zdhc2:'最大回撤（%）',
    zq:'周期（天）',
    jbsj:'基本数据',
    fx:'分享',
    sc:'收藏',
    ysc:'已收藏',
    zsy:'总收益',
    zrj:'总入金',
    zcj:'总出金',
    zdhcl:'最大回撤率（值）',
    zdfk:'最大浮亏',
    zdds:'总订单数',
    dbzdjyl:'单笔最大交易量',
    t:'天',
    zhhbdw:'账户货币单位',
    ckqb:'查看全部',
    anyue:'按月',
    jidu:'季度',
    bannian:'半年',
    yinian:'1年',
    ernian:'2年',
    sanian:'3年',
    jzye:'净值/余额（$）',
    crj:'出入金（$）',
    cj:'出金',
    rj:'入金',
    ysyl:'月收益率',
    yiyue:'1月',
    eryue:'2月',
    sanyue:'3月',
    siyue:'4月',
    wuyue:'5月',
    liuyue:'6月',
    qiyue:'7月',
    bayue:'8月',
    jiuyue:'9月',
    shiyue:'10月',
    shiyiyue:'11月',
    shieryue:'12月',
    ccxj:'持仓细节',
    cq:'产品',
    dk:'多/空',
    ss:'手数',
    yk2:'盈/亏',
    hlzb:'衡量指标',
    ylddcxsjpj:'盈利订单持仓时间',
    ksddcxsjpj:'亏损订单持仓时间',
    dgddylpj:'单个订单盈利',
    dgddkspj:'单个订单亏损',
    dgddlrzd:'单个订单利润',
    dgddkszd:'单个订单亏损',
    syl:'收益率',
    sjbl:'数据比例',
    sl:'胜率',
    zdjybl:'自动交易比率',
    pcddmx:'平仓订单明细',
    pcjg:'平仓价格',
    sxf:'手续费',
    tbxtccsc:'同步系统操作手册',
    zhzc:'账号注册',
    xtdl:'系统登录',
    jzhszwxh:'将账号设置为信号？',
    sztbxh:'设置同步信号', 
    wzjs:"JCLH将MT4或MT5下跨交易商多账户集中在平台内进行垂直管理，并为用户提供全部账户的数据汇聚、风险分析、财务汇总、信息分享和账户间数据同步的服务。",
    mzsmText:`<p  style="font-weight: bold; color: windowtext; text-align: center; ">
		<strong><span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
		免责声明</span>
		</strong>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明是由 JCLH与在网站www.JCLH.biz上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		   <span>
				
				本网站已采取谨慎的措施对信息进行核实，但并不保证所含信息全部准确。请您理解我们的信息可能会不全面，或有疏漏或滞后。本网站或独立信息提供者均不会对任何因信息错误、不完整、迟延、不精确或基于对本网站信息的依赖而产生的损失承担任何责任。所有预测或观点(如未来汇率变动的预测)以及基于这些预测而进行的交易活动，仅代表第三方的个人观点和行为，并不代表本网站的立场。您须理解，第三方的预测不代表任何形式的业绩承诺，请不要直接或者间接地效仿。您必须进行独立分析以做出投资判断，同时应了解，在基于本网站内容做出判断所进行的投资行为可能产生实际的盈利或亏损。您基于本网站提供的交易策略和信号，运用个人配置交易系统所做出的投资行为是您自己决定的结果，需自行承担所有风险。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		  
				
				本网站明确表明，本网站的管理平台仅适用于对高风险投资有一定了解的用户。您可以使用空闲的资金进行投资，而不应该影响到日常生活的开支。任何交易策略在过去取得的业绩均不能代表其将来的表现。一般未来汇率变动是不可预测的，这也就表明任何个人策略、金融顾问、手动或者自动交易系统都不能保证任何形式的预测可能产生利润，所以对待投资预测一定要经过自己的分析做出判断，切忌盲从。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;"><span>基于网站或网络传输延时可能导致数据存在偏差（包括但不限于可能由于交易员修改密码或其他网络原因导致的账户断连造成订单跟随关系丢失），因此，用户在使用交易系统、交易跟随系统形成、产生交易后，应及时查看交易系统中交易数据的变化。无论是 JCLH 或是本网站任何合作伙伴都不能保证，您基于 JCLH 提供的信息及使用个人配置交易系统进行投资一定会盈利。除此之外， JCLH 作为跟随交易系统的开发者，不会对任何由于第三方(如作为这项服务的提供者公司或者交易商)延误、疏忽而导致的客户损失承担责任。除了以上， JCLH 明确表明不会对交易员提供的策略和交易信号承担任何责任。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				JCLH 所属公司注册所在地法律、法规应适用于本声明以及管辖本声明各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				在合约一方寻求实现本声明下的权利，或寻求宣告本声明下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。
			   
			</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明的解释语言应为中文。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
	`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
			<strong>
				<span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
					隐私政策
				</span>
			</strong>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1. 我们收集的信息类型
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				我们主要收集三类信息。
			</span>
		</p>

		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				1.1 您向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				使用 JCLH 的必要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.1 账号信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.2 您选择向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				交易风控信息。您可选择提供设置账户交易时使用的风控策略。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.2 您使用 JCLH 时，我们自动收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Cookies 及类似技术。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.3 我们通过第三方收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.我们如何使用所收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.1 创建和维护一个受到信任的以及更安全的环境
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				检测和预防欺诈、滥用、安全事件及其他有害活动。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				开展安全调查和风险评估。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				执行我们的服务条款及其他政策。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.分享与披露
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.1 征得您的同意
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.2 业务转移
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.3汇总信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.其他重要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.1 关联第三方账号
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.您的权利
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.1 管理您的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.2 不准确或不完整的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.4 数据保留与删除
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				请注意，如果您申请删除您的个人信息：
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				6. 全球运营
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				7.安全
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				8.本《隐私政策》的变更
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				9.联系我们
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
			</span>
		</p>
	`,
	fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
		<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
		</p>
		<p>
		<br/>
	</p>`,
    mzsmbt:"免责声明",
	qwzxcz:"为保证账号跟单收益,请勿自行操作!",
	wdzl:"我的资料",
	wdqb:"我的钱包",
	hyfw:"会员服务",
	wdtd:"我的团队",
	tcdl:"退出登录",
	xhgl:"信号管理",
	sfgz:"收费规则：以资金和信号资金1:1为基础定价；用户订阅费动态更新、按天扣除。",
	jcdyf:"基础订阅费",
	yhdyf:"用户订阅费",
	zhye:"账户余额",
	xhye:"信号余额",
	yf:"月",
	bkxzjygz:"当前不可选择交易规则",
	bksrjycs:"当前不可输入交易参数",
	hand:"手",
	pcjl:"平仓记录",
	tdxx:"团队信息",
	wdyqm:"我的邀请码",
	fz:"复制",
	yqmsjh:"推荐邀请码/手机号",
	bangd:"绑定",
	agree:"我同意",
	mzsm:"免责声明",
	and:"和",
	fwtk:"服务条款",
	qhyy:"切换语言",
	zhong:"中文",
	ying:"英文",
	wei:"维语",
	tai:"泰语",
	han:"韩语",
	ri:"日语",
	
	kyye:"可用JCLHoin余额",
	yets:"JCLHoin是一种代币，只可以在 JCLH 社区使用，用户之间不能转让，不能赎回。由 JCLH 运营。通过购买点数兑换获得。 JCLHoin 可用于支付订阅费，兑换奖品和其他站内行为。详情参阅《JCLHoin购买与使用协议》",
	zffs:"支付方式",
	
	szhb:"数字货币",
	wxzf:"微信支付",
	zfb:"支付宝",
	yl:"银联",
	xyk:"信用卡",
	szjl:"收支记录",
	
	szsj:"时间",
	szsl:"数量",
	szxm:"项目",
	szzt:"订单状态",
	szbh:"订单编号",
	
	dqdj:"当前等级",
	yxq:"有效期至",
	shengj:"升级",
	hygm:"欢迎购买JCLH会员",
	zfje:"支付金额",
	xfjl:"消费记录",
	xfje:"金额",
	
	dzgl:"关联",
	dzg:"个",
	dzzh:"账户",
	
	a1:'购买数量',
	a2:'会员等级',
	a3:'账号数量',
	a4:'操作',
	a5:'待上传凭证',
	a6:'支付成功',
	a7:'支付失败',
	a8:'上传凭证',
	a9:'查看支付',
	a10:'支付',
	a11:'数字货币',
	a12:'钱包地址',
	a13:'复制地址',
	a14:'复制钱包地址至进行支付',
	a15:'二维码',
	a16:'金额',
	a17:'确定',
	a18:'取消',
	a19:'关闭',
	a20:'复制成功',
	a21:'上传凭证',
	a22:'查看凭证',
	a23:'待审核',
	a24:'保证金等比',
	a25:'净值等比',
	a26:'可用资金等比',
	a27:'交易量等比',
	a28:'固定手数等比',
	a29:'反向跟单',
	a30:'开仓补偿',
	a31:'平仓补偿',
	a32:'已选',
	a33:'是否开启当前账号',
	a34:'是否暂停当前账号',
	a35:'同步操作',
	a36:'限定一个账号',
	a37:'不限购买账号数量',
	
	a38:'试用版会员',
	a39:'基础版会员',
	a40:'专业版会员',
	a41:'机构版会员',
	a42:'请设置手机号码',
	a43:'请设置邮箱',
	a44:'请输入邀请码',
	a45:'上传头像图片只能是 JPG 格式!',
	a46:'上传头像图片大小不能超过 2MB!',
	a47:'暂无同步数据',
	a48:'总手数',
	a49:'是否将其置为',
	a50:'启用',
	a51:'禁用',
	a52:'状态',
	a53:'确认要删除此账号吗',
	a54:'已复制！',
	a55:'请输入交易参数',
	a56:'新密码与确认密码不一致!',
	a57:'日收益',
	a58:'平均',
	a59:'最大',
	a60:'刷新成功',
	a61:'生产率',
	a62:'不合格',
	a63:'合格',
	a64:'胜率',
	a65:'出金',
	a66:'入金',
	a67:'余额',
	a68:'净值',
	a69:'日盈亏',
	a70:'请输入数值',
	a71:'该信号暂无同步者',
	a72:'登录状态已过期,请重新登录!',
	a73:'短信已发送,请注意查收.',
	a74:'验证码已发送!',
	a75:'登录成功!',
	a76:'用户姓名不能为空',
	a77:'手机号码不能为空',
	a78:'未同意用户协议和隐私政策',
	a79:'会员升级',
	a80:'选择类型',
	a81:'当前有效期至',
	a82:'折算有效期至',
	a83:'注：折算后的有效期是系统自动计算得出。',
	a84:'将文件拖到此处',
	a85:'或',
	a86:'点击上传',
	a87:'您已是最高等级会员，无法继续升级.',
	a88:'审核中',
	a89:'暂不支持此支付方式',
	a90:'重置密码',
	a91:'想起来了',
	a92:'美国',
	a93:'中国',
	a94:'香港',
	
	a95:'风险提醒',
	a96:'本智能量化社区主要提供标准化交易信号，供用户参考使用。',
	a97:'为确保策略有效性并控制执行偏差',
	a98:'建议单个量化标的的资金规模不低于 20000 USD',
	a99:'若投入资金低于该基准，可能因资金规模不足而放大相对风险，影响策略稳定性',
	a100:'请您在开始任何操作前，务必根据自身财务状况和风险承受能力',
	a101:'自行设置账户的风险保护机制',
	a102:'所有量化交易行为均为您个人独立决策，相关盈亏及因市场波动、系统故障、政策变动等不可抗力因素所导致的损失',
	a103:'均由您本人承担',
	a104:'本社区所提供的信号仅作信息参考',
	a105:'不构成投资建议、要约或担保',
	a106:'本智能量化社区',
	a107:'不对任何交易结果或资金损失承担责任',
	a108:'请充分理解并确认接受上述风险后再进行操作',
	a109:'我已了解',
	
	a110:'暂无等级',
	
	zhlb:'账户列表',
}
















